import React from "react";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import DropZone from "../../component/dropzone/DropZone";

const AddMedia = () => {
  return (
    <>
      <Breadcrumb txt="Manage Media" subpath={["Add Media"]} />
      <DropZone url="media" title="Add Media" navigate="viewmedia" media bigSize />
    </>
  );
};

export default AddMedia;
